import { useEffect, useId } from 'react'
import { useWarnBrowseAwayContext } from './WarnBrowseAwayProvider'

interface UseWarnBrowseAwayOptions {
  isDirty: boolean
  label?: string
}

export const useWarnBrowseAway = ({ isDirty, label }: UseWarnBrowseAwayOptions) => {
  const { registerDirtyFlag, unregisterDirtyFlag } = useWarnBrowseAwayContext()
  const id = useId() + (label ? '-' + label : '')

  useEffect(() => {
    registerDirtyFlag(id, isDirty)
    return () => {
      unregisterDirtyFlag(id)
    }
  }, [id, isDirty, registerDirtyFlag, unregisterDirtyFlag])
  return { id }
}
